import { zodResolver } from "@hookform/resolvers/zod";
import { Box, Button, useTheme } from "@mui/material";
import type { FC } from "react";
import { useForm } from "react-hook-form";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import {
	type RenameFolderFormInput,
	type RenameFolderFormOutput,
	renameFolderFormSchema,
} from "web_myplann/Portfolio/Forms/RenameFolderForm/renameFolderFormSchema";
import { FlatRowFormStackedInput } from "web_myplann/Shared/Components/FlatRow/FlatRowFormStackedInput";

const R = Resources.Portfolio.List.DocumentActionsDrawer.Rename;

type Props = {
	title: string;
	onSubmit: (title: string) => void;
};

export const RenameFolderForm: FC<Props> = ({ title, onSubmit }) => {
	const form = useForm<RenameFolderFormInput, unknown, RenameFolderFormOutput>({
		resolver: zodResolver(renameFolderFormSchema),
		defaultValues: { title },
		mode: "onChange",
	});
	const { spacingTokens } = useTheme();
	const { t } = useResource();

	const handleSubmit = form.handleSubmit(({ title }) => onSubmit(title));

	return (
		<Box component="form" onSubmit={handleSubmit}>
			<FlatRowFormStackedInput
				control={form.control}
				name="title"
				label={t(R.folderRename)}
				isLast
			/>
			<Box px={spacingTokens.lg} py={spacingTokens.lg}>
				<Button
					type="submit"
					variant="primary"
					disabled={!form.formState.isValid}
				>
					{t(R.submit)}
				</Button>
			</Box>
		</Box>
	);
};
